// /terms — Terms of Service (public, no auth). Static page without a data
// layer: the wording lives in the `legal.terms.*` i18n catalog (draft text;
// the owner approves the final edit via PR review).

import type { ReactElement } from 'react';

import { LegalPageLayout, type LegalSection } from './LegalPageLayout.js';

/** Revision of the current draft; update together with the catalog wording. */
const TERMS_REVISION_DATE = new Date(2026, 9, 21);

const SECTIONS: readonly LegalSection[] = [
  {
    titleKey: 'crm.legal.terms.service.title',
    bodyKey: 'crm.legal.terms.service.body',
  },
  {
    titleKey: 'crm.legal.terms.account.title',
    bodyKey: 'crm.legal.terms.account.body',
  },
  {
    titleKey: 'crm.legal.terms.plans.title',
    bodyKey: 'crm.legal.terms.plans.body',
  },
  {
    titleKey: 'crm.legal.terms.responsibility.title',
    bodyKey: 'crm.legal.terms.responsibility.body',
  },
  {
    titleKey: 'crm.legal.terms.changes.title',
    bodyKey: 'crm.legal.terms.changes.body',
  },
  {
    titleKey: 'crm.legal.terms.contacts.title',
    bodyKey: 'crm.legal.terms.contacts.body',
  },
];

export function TermsPage(): ReactElement {
  return (
    <LegalPageLayout
      titleKey="crm.legal.terms.title"
      introKey="crm.legal.terms.intro"
      updatedKey="crm.legal.updated"
      revisionDate={TERMS_REVISION_DATE}
      sections={SECTIONS}
      relatedLinks={[
        { to: '/privacy', labelKey: 'crm.legal.link.privacy' },
        { to: '/support', labelKey: 'crm.legal.link.support' },
      ]}
    />
  );
}
